import {Redirect, Route, Switch} from 'react-router-dom';
import ASScene from './ASScene';
import Urls from '../../constants/urls';
import {
  c4BackCarHotspots,
  frontCarHotspots,
  incCarHotspots,
  loungeHotspots,
  frontEntranceHotspots
} from './data';

const ASRooms = () => {
  return (
    <Switch>
      <Route 
        {...Urls.AutoShowroom.root}
        render={() => <Redirect to={Urls.AutoShowroom.frontEntrance.path} />}  
      />
      <Route {...Urls.AutoShowroom.c4BackCar}>
        <ASScene 
          id="as-back-car"
          yRotation={270}
          hotspots={c4BackCarHotspots}
        />
      </Route>
      <Route {...Urls.AutoShowroom.frontCar}>
        <ASScene
          id="as-front-car"
          yRotation={-90}
          hotspots={frontCarHotspots}
        />
      </Route>
      <Route {...Urls.AutoShowroom.incCar}>
        <ASScene 
          id="as-in-car"
          yRotation={270}
          hotspots={incCarHotspots}
        />
      </Route>   
      <Route {...Urls.AutoShowroom.lounge}>
        <ASScene
          id="as-lounge"
          yRotation={-88}
          hotspots={loungeHotspots}
        />
      </Route>
      <Route {...Urls.AutoShowroom.frontEntrance}>
        <ASScene
          id="as-front-entrance"
          yRotation={190}
          hotspots={frontEntranceHotspots}
        />
      </Route>   
    </Switch>
  );
};

export default ASRooms;
